import { render } from "./CombatLogTimeChart.vue?vue&type=template&id=427c2471"
import script from "./CombatLogTimeChart.vue?vue&type=script&lang=js"
export * from "./CombatLogTimeChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__